/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppMediaExportJobEnqueueDtoTypeEnum = {
    AUDIO: "AUDIO",
    VIDEO: "VIDEO",
    IMAGE: "IMAGE"
} as const;

export type WebAppMediaExportJobEnqueueDtoTypeEnumKey = (typeof WebAppMediaExportJobEnqueueDtoTypeEnum)[keyof typeof WebAppMediaExportJobEnqueueDtoTypeEnum];

/**
 * MediaExportJobEnqueueWithType
 * @description Body for enqueuing an export job.
*/
export type WebAppMediaExportJobEnqueueDto = {
    /**
     * @description Station identifier
     * @type string
    */
    stationId: string;
    /**
     * @description Media type (audio or video)
     * @type string
    */
    type: WebAppMediaExportJobEnqueueDtoTypeEnumKey;
    /**
     * @type string
    */
    from: string;
    /**
     * @type string
    */
    to: string;
};